import { DiContainerInjectFn } from '@@/di/ts';
import { DlpService } from './services/dlp.service';

export default ((container) => {
  container.bind(DlpService).to(DlpService).inSingletonScope();
}) as DiContainerInjectFn;
